module.exports = __webpack_public_path__ + "img/Harp Ecademy.b2a137e3.jpg";